import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Loading } from '@cubeyou-team/hx-react-components';
import {
  StyledCreateAudienceModal,
  StyledCreateAudienceModalMain,
  StyledCreateAudienceModalContent,
  StyledCreateAudienceModalContentLeft,
  StyledCreateAudienceModalContentRight,
} from './StyledCreateAudienceModal';

import {
  QueryBuilderContainer,
  TaxonomyExplorerContainer,
  ConversationExplorerContainer,
} from '../../containers';
import CreateAudienceHeader from './components/CreateAudienceHeader';

const CreateAudienceModal = ({
  onCreateAudienceModalClose,
  queryBuilder,
  conversation,
  createAudienceModal,
}) => {
  const notConversation = queryBuilder.queryBuilderType !== 'conversation';
  return (
    <StyledCreateAudienceModal data-test-id="create-audience-modal">
      <StyledCreateAudienceModalMain>
        <CreateAudienceHeader
          onCreateAudienceModalClose={onCreateAudienceModalClose}
        />
        <StyledCreateAudienceModalContent>
          <StyledCreateAudienceModalContentLeft>
            <QueryBuilderContainer
              onCreateAudienceModalClose={onCreateAudienceModalClose}
            />
          </StyledCreateAudienceModalContentLeft>
          <StyledCreateAudienceModalContentRight
            id={notConversation ? 'gtTaxonomyExplorer' : undefined}
          >
            <Loading
              isLoading={
                queryBuilder.isLoading ||
                conversation.isFetchingRecentConversations ||
                conversation.isLoading ||
                createAudienceModal.isLoading
              }
              hideMode
            >
              {notConversation ? (
                <TaxonomyExplorerContainer />
              ) : (
                <ConversationExplorerContainer />
              )}
            </Loading>
          </StyledCreateAudienceModalContentRight>
        </StyledCreateAudienceModalContent>
      </StyledCreateAudienceModalMain>
    </StyledCreateAudienceModal>
  );
};

CreateAudienceModal.propTypes = {
  isQueryValid: PropTypes.bool,
  onCreateAudienceModalClose: PropTypes.func,
  onCreateAudienceRequest: PropTypes.func,
};

const mapStateToProps = state => ({
  queryBuilder: state.queryBuilder,
  conversation: state.conversation,
  createAudienceModal: state.createAudienceModal,
});

export default connect(mapStateToProps)(CreateAudienceModal);
